import { initChildren } from "../../atoms/icons/icons";

export interface ToastOptions {
  title?: string;
  content?: string;
  position?: ToastPosition;
  duration?: number;
  animate?: boolean;
  dismissOthers?: boolean;
  dismissable?: boolean;
  type?: ToastType;
}

export enum ToastType {
  Info = "info",
  Warning = "warning",
  Success = "success",
  Error = "error",
}

export enum ToastPosition {
  Top = "top",
  TopLeft = "topLeft",
  TopRight = "topRight",
  Bottom = "bottom",
  BottomLeft = "bottomLeft",
  BottomRight = "bottomRight",
}

const _toastIconClass = (type: ToastType): string => {
  switch (type) {
    case ToastType.Info:
      return "ico-info-circle-16";
    case ToastType.Error:
      return "ico-cross-circle-16";
    case ToastType.Warning:
      return "ico-alert-triangle-16";
    case ToastType.Success:
      return "ico-checkmark-circle-16";
    default:
      return "";
  }
};

const _toastTypeClass = (type: ToastType): string => {
  switch (type) {
    case ToastType.Error:
      return "notification--error";
    case ToastType.Info:
      return "notification--info";
    case ToastType.Success:
      return "notification--success";
    case ToastType.Warning:
      return "notification--warn";
  }
};

const _toastPositionClass = (position: ToastPosition): string[] => {
  let classes: string[] = [];
  switch (position) {
    case ToastPosition.Top:
    case ToastPosition.TopLeft:
    case ToastPosition.TopRight:
      classes.push("notification--top");
      break;
    default:
      classes.push("notification--bottom");
      break;
  }
  switch (position) {
    case ToastPosition.TopLeft:
    case ToastPosition.BottomLeft:
      classes.push("notification--left");
      break;
    case ToastPosition.TopRight:
    case ToastPosition.BottomRight:
      classes.push("notification--right");
      break;
  }
  return classes;
};

const toastQueue: Record<ToastPosition, HTMLElement[]> = {
  [ToastPosition.Top]: [],
  [ToastPosition.TopLeft]: [],
  [ToastPosition.TopRight]: [],
  [ToastPosition.Bottom]: [],
  [ToastPosition.BottomLeft]: [],
  [ToastPosition.BottomRight]: [],
};

const _translation = (pos: ToastPosition, yOffset: number): string => {
  let trans = "";
  switch (pos) {
    case ToastPosition.Top:
    case ToastPosition.Bottom:
      trans += `translateX(-50%) `;
      break;
  }
  switch (pos) {
    case ToastPosition.Bottom:
    case ToastPosition.BottomLeft:
    case ToastPosition.BottomRight:
      yOffset = 0 - yOffset;
      break;
  }
  trans += `translateY(${yOffset}px)`;
  return trans;
};

const updatePositions = (pos: ToastPosition): void => {
  let currHeight = 0;
  toastQueue[pos].forEach((el, i) => {
    el.style.transform = _translation(pos, currHeight);
    currHeight += el.getBoundingClientRect().height + 8;
  });
};

const _clearToast = (toastElement: HTMLElement, position: ToastPosition) => {
  clearTimeout(toastElement["canceler"]);
  document.body.removeChild(toastElement);
  toastQueue[position] = toastQueue[position].filter((e) => e != toastElement);
  updatePositions(position);
};

export const toast = ({
  title,
  content,
  position = ToastPosition.BottomLeft,
  duration = 3000,
  dismissOthers = false,
  type = ToastType.Info,
  dismissable = true,
}: ToastOptions) => {
  let template = `
<div class="notification notification--toast ${_toastTypeClass(
    type
  )} notification--dynamic ${_toastPositionClass(position).join(" ")}">
    <i class="icon ${_toastIconClass(type)} notification__icon"></i>
    <div class="notification__content">
        <span class="notification__title">${title}</span>
        <p>${content}</p>
    </div>
    ${
      dismissable
        ? `
    <div class="notification__closer">
        <i class="icon ico-x icon--smaller"></i>
    </div>
    `
        : ""
    }
</div>
`;

  if (dismissOthers) {
    toastQueue[position].forEach((e) => {
      _clearToast(e, position);
    });
  }

  var wrapper = document.createElement("div");
  wrapper.innerHTML = template;
  var toastElement = wrapper.children[0] as HTMLElement;
  if (dismissable) {
    toastElement
      .querySelector(".notification__closer")
      .addEventListener("click", () => {
        _clearToast(toastElement, position);
      });
  }
  document.body.appendChild(toastElement);
  initChildren(toastElement);

  let fullHeightOfExisting = toastQueue[position]
    .map((e) => e.getBoundingClientRect().height + 8)
    .reduce((prev, cur) => prev + cur, 0);
  console.log(fullHeightOfExisting);

  setTimeout(() => {
    updatePositions(position);
  }, 0);

  toastQueue[position].push(toastElement);
  toastElement["canceler"] = setTimeout(() => {
    _clearToast(toastElement, position);
  }, duration);
};

export default {
  toast,
  ToastType,
  ToastPosition,
};
